import { render } from "./QuoteEdit.vue?vue&type=template&id=6b23e14c&scoped=true"
import script from "./QuoteEdit.vue?vue&type=script&lang=js"
export * from "./QuoteEdit.vue?vue&type=script&lang=js"

import "./QuoteEdit.vue?vue&type=style&index=0&id=6b23e14c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b23e14c"]])

export default __exports__